var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role)?_c('RoleForm',{attrs:{"role":_vm.role,"isEdit":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }